import React, { useState } from "react";
import axios from "axios";
import { config } from "../../config.jsx";
import Switch from '@mui/material/Switch';
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 0.25rem;
  border-radius: 5px;
  background-color: #152451;
`

const SwitchLabel = styled.div`
  color: ${(props) => props.is_true ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.5)'};
  text-align: left;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0.5rem;
  font-size: 18px;
  font-weight: bold;
`

export default function AnnounceBtn(props) {
  const { category } = props;
  const [autoCall, setAutoCall] = useState(false);
  const [error, setError] = useState(null);

  console.log("AnnounceBtn category:", category);

  const execAnnounce = async () => {
    console.log("Executing announce for category:", category);
    setError(null);
    try {
      const url = `${config.restUrl}/announce/`;
      const res = await axios.get(url);
      console.log("Announce response:", res.data);

      if (!res.data.status || res.data.status !== 'success') {
        setError("アナウンスの取得に失敗しました");
        return;
      }

      // base64文字列をBlobに変換
      const byteString = atob(res.data.data);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      const audioBlob = new Blob([byteArray], { type: 'audio/wav' });

      // audioタグで再生
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.play();
    } catch (e) {
      setError("データが見つかりませんでした");
    }
  }

  // autoCallがtrueの場合は自動で音声案内を開始
  // 1時間に1回実行する
  React.useEffect(() => {
    let interval;
    if (autoCall) {
      execAnnounce();
      interval = setInterval(() => {
        execAnnounce();
      }, 1000 * 60 * 30); // 30分ごとに実行
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [autoCall, category]);

  return (
    // 音声案内のトグルボタン
    <Wrapper>
        <Switch
          checked={autoCall}
          onChange={() => setAutoCall(!autoCall)}
          color="primary"
        />
        <SwitchLabel is_true={autoCall}>
          音声案内を{autoCall ? "停止" : "開始"}
        </SwitchLabel>
    </Wrapper>
  );
}
